module.exports = __webpack_public_path__ + "img/icon-key.49b866e7.svg";